import React from 'react'
import "./TopHeader.css"
import 'bootstrap/dist/css/bootstrap.min.css';

import {BsGithub } from "react-icons/bs"; 
import {BsLinkedin} from "react-icons/bs"; 
import { BsFacebook } from "react-icons/bs"; 
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";



export default function TopHeader() {
  return (
    <div>

      <div className="footer-socials">
      <a href="  https://www.linkedin.com/in/niraj-yadav-88024a227/ ">
      <BsLinkedin/>
        </a>
      <a href="https://github.com/niraj2634">
     < BsGithub/>
        </a>
        <a href="https://facebook.com">
          <BsFacebook />
        </a>

        <a href="https://instagram.com">
          <BsInstagram />
        </a>
        <a href="https://twitter.com">
          <BsTwitter />
        </a>
      </div>










    </div>
  )
}
